import type { ReactNode } from 'react';
import { Transition } from 'react-transition-group';

import { useIsMounted } from '@simplywallst/ui-core';

import { useDeviceFixedBottom } from '../hooks/useDeviceFixedBottom';
import { useSwipeContext } from '../SwipeContext';
import { useTransitionStatusContext } from '../TransitionStatusContext';
import { transitionTimeouts } from '../constants';

import type { SheetLayout } from './styled';
import { StyledSheet } from './styled';

interface Props {
  zIndex?: number;
  children: ReactNode;
  sheetLayout?: SheetLayout;
}

export const Sheet = ({ zIndex = 9999, children, sheetLayout }: Props) => {
  const hasMounted = useIsMounted();
  const { swipeRef } = useSwipeContext();
  const { state } = useTransitionStatusContext();

  useDeviceFixedBottom({ ref: swipeRef });

  return (
    <Transition
      in={hasMounted && state !== 'exiting'}
      mountOnEnter
      unmountOnExit
      nodeRef={swipeRef}
      timeout={transitionTimeouts}
    >
      {(state) => (
        <StyledSheet
          role="presentation"
          aria-label="overlay content"
          ref={swipeRef}
          zIndex={zIndex}
          templateRows="1fr"
          templateColumns="1fr"
          transitionStatus={state}
          sheetLayout={sheetLayout}
        >
          {children}
        </StyledSheet>
      )}
    </Transition>
  );
};
